export const SCREENS = {
  SELECT_RESTAURANT: "SELECT_RESTAURANT",
  SELECT_MENU_ITEMS: "SELECT_MENU_ITEMS",
  SECRET_VERIFICATION: "SECRET_VERIFICATION",
  COUPLING: "COUPLING",
  GET_ADDRESS: "GET_ADDRESS",
  ADDRESS_WAIT_SCREEN: "ADDRESS_WAIT_SCREEN",
  CONTACT: "CONTACT",
  HELP: "HELP",
  NUDGE: "NUDGE",
  MY_PARTNER: "MY_PARTNER",
  INTEGRATIONS: "INTEGRATIONS",
  PLAN_NEW_DATE: "PLAN_NEW_DATE",
  CHECKOUT: "CHECKOUT",
  MEET_CONCIERGE: "MEET_CONCIERGE",
  BOND_OVER_MEMORIES: "BOND_OVER_MEMORIES",
  GET_READY: "GET_READY",
}
